import { RuleValidator } from '../types';

export const fileRules: Record<string, RuleValidator> = {
    file: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;

        if (typeof File !== 'undefined' && value instanceof File) return true;
        if (typeof Blob !== 'undefined' && value instanceof Blob) return true;

        const tag = Object.prototype.toString.call(value);
        if (tag === '[object File]' || tag === '[object Blob]') return true;

        return !!(value &&
            typeof value === 'object' &&
            typeof (value as any).size === 'number' &&
            (typeof (value as any).type === 'string' || typeof (value as any).type === 'undefined') &&
            (typeof (value as any).arrayBuffer === 'function' || typeof (value as any).slice === 'function'));
    },

    mime: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!fileRules.file(value, [], data)) return false;

        if (typeof value?.type === 'string') {
            return params.includes(value.type);
        }

        return false;
    },

    maxSize: (value: any, params: any[], _data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;

        const size = typeof value?.size === 'number' ? value.size : NaN;
        const limit = Number(params?.[0]);

        if (!Number.isFinite(size) || !Number.isFinite(limit)) return false;
        return size <= limit;
    },

    minSize: (value: any, params: any[], _data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;

        const size = typeof value?.size === 'number' ? value.size : NaN;
        const limit = Number(params?.[0]);

        if (!Number.isFinite(size) || !Number.isFinite(limit)) return false;
        return size >= limit;
    }

};